<template>
    <v-container>
        <div class="flex-h" style="justify-content: space-between; align-items: center; margin-top: 10px; margin-bottom: 20px;">
            <div class="text-h3">События</div>
            <div style="margin-left: 20px;">
                <b>за</b>&nbsp;
                <DatePicker
                    v-model="dateFilterRange"
                    range
                    type="date"
                    :valueType="sqlDateTimeFormat"
                    :format="displayDateFormat"
                    range-separator=" — "
                />
            </div>
            <v-spacer />
        </div>

        <EventBrowser
            ref="browser"
            :filters="filters"
        />
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import EventBrowser from '@/components/browsers/EventBrowser.vue'
import DatePicker from 'vue2-datepicker'
import {DISPLAY_DATE_FORMAT, setMidnight, SQL_DATE_TIME_FORMAT} from '@/utils/datetime'
import day from 'dayjs'

@Component({
    components: {DatePicker, EventBrowser},
})
export default class EventsView extends Vue
{
    sqlDateTimeFormat = SQL_DATE_TIME_FORMAT
    displayDateFormat = DISPLAY_DATE_FORMAT

    occurredSince: string | null = null
    occurredTill: string | null = null

    async created() {
        this.occurredSince = setMidnight(day().subtract(7, 'day')).format(this.sqlDateTimeFormat)
        this.occurredTill = setMidnight(day()).format(this.sqlDateTimeFormat)
    }

    get dateFilterRange(): [string, string] {
        return [this.occurredSince || '', this.occurredTill || '']
    }

    // noinspection JSUnusedGlobalSymbols
    set dateFilterRange([since, till]: [string, string]) {
        this.occurredSince = since
        this.occurredTill = till
    }

    get filters() {
        return {
            occurredSince: this.occurredSince
                ? day(this.occurredSince, this.sqlDateTimeFormat).utc().format(this.sqlDateTimeFormat)
                : null,
            occurredTill: this.occurredTill
                ? day(this.occurredTill, this.sqlDateTimeFormat).utc().add(1, 'day').format(this.sqlDateTimeFormat)
                : null,
        }
    }
}
</script>
